import {Navigate, useLocation} from "react-router-dom";
import {RoutePaths} from "../../../../util/constants";
import {ReactElement} from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../../../store";

type Props = {
    showRoute: boolean;
    redirectTo?: RoutePaths;
    children: ReactElement;
};

export default function ProtectedRoute({
                                           showRoute,
                                           redirectTo = RoutePaths.HOME,
                                           children,
                                       }: Props) {
    const location = useLocation();
    const appLoading = useSelector((state: RootState) => state.appReducer.appLoading)

    // Extract redirect target from router state (preferred) or query param (backward compatible).
    const stateRedirect = (location.state as { redirectTo?: string } | null)?.redirectTo;
    const params = new URLSearchParams(location.search);
    const redirectParam = params.get("redirect");

    const normalizeRedirect = (value?: string | null): string | null => {
        if (!value) return null;
        const trimmed = value.trim();
        if (!trimmed.startsWith("/") || trimmed.startsWith("//")) {
            return null;
        }
        return trimmed;
    };

    const finalRedirect = normalizeRedirect(stateRedirect) || normalizeRedirect(redirectParam) || redirectTo;

    return showRoute || appLoading ? children : <Navigate to={finalRedirect} replace/>;
}
